import { FormattedMessage } from 'react-intl';
import offlineMapsSrc from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/images/feature-thumb-offline-maps.avif';
import trailConditionsSrc from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/images/feature-thumb-trail-conditions.avif';
import wrongTurnAlertsSrc from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/images/feature-thumb-wrong-turn-alerts.avif';
import UpsellFeatureList from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/UpsellFeatureList';
import corosSrc from './coros.avif';
import liveShareSrc from './feature-thumb-live-share.avif';
import memberDealsSrc from './feature-thumb-member-deals.avif';
import garminSrc from './feature-thumb-send-to-garmin.avif';

const memberDealsRow = {
  body: <FormattedMessage defaultMessage="Exclusive savings on apparel, outdoor accommodations, flights, and more" />,
  src: memberDealsSrc,
  title: <FormattedMessage defaultMessage="Member Deals" />
};

const offlineMapsRow = {
  body: <FormattedMessage defaultMessage="Download maps so you always know where you are, even without cell service" />,
  src: offlineMapsSrc,
  title: <FormattedMessage defaultMessage="Offline Maps" />
};

const trailConditionsRow = {
  body: <FormattedMessage defaultMessage="Plan for trail-specific weather, snow depth, and more" />,
  src: trailConditionsSrc,
  title: <FormattedMessage defaultMessage="Trail Conditions" />
};

const wrongTurnAlertsRow = {
  body: <FormattedMessage defaultMessage="Focus on the beauty around you, not the map, with wrong-turn alerts" />,
  src: wrongTurnAlertsSrc,
  title: <FormattedMessage defaultMessage="Wrong-Turn Alerts" />
};

const garminRow = {
  body: <FormattedMessage defaultMessage="Have the route at your wrist. Upload AllTrails routes to your Garmin device" />,
  src: garminSrc,
  title: <FormattedMessage defaultMessage="Send Routes to Garmin" />
};

const liveShareRow = {
  body: <FormattedMessage defaultMessage="Keep your loved ones in the loop by sharing your real-time trail activity" />,
  src: liveShareSrc,
  title: <FormattedMessage defaultMessage="Live Share" />
};

const usDefaultRows = [offlineMapsRow, trailConditionsRow, memberDealsRow, wrongTurnAlertsRow, garminRow];
const usMemberDealsFirstRows = [memberDealsRow, offlineMapsRow, trailConditionsRow, wrongTurnAlertsRow, garminRow];
const nonUsRows = [offlineMapsRow, trailConditionsRow, wrongTurnAlertsRow, garminRow, liveShareRow];

// TODO translate: https://alltrails.atlassian.net/browse/GROW-18496
const reiRows = [
  {
    body: 'Download trails, parks, and areas to stay on route without cell signal',
    src: offlineMapsSrc,
    title: 'Unlimited Map Downloads'
  },
  {
    body: 'Plan for trail-specific weather, snow depth, and more',
    src: trailConditionsSrc,
    title: 'Real-time Trail Conditions'
  },
  {
    body: 'Focus on the beauty around you, not the map, with wrong-turn alerts',
    src: wrongTurnAlertsSrc,
    title: 'Wrong-Turn Alerts'
  },
  {
    body: 'Sync your wearable to AllTrails to get routes on your wrist, track your activities, and more',
    src: corosSrc,
    title: 'Connect Garmin & COROS'
  }
];

type Props = {
  isInUs: boolean;
  isRei?: boolean;
  memberDealsFirst?: boolean;
};

export default function PlusMembershipIncludes({ isInUs, isRei, memberDealsFirst }: Props) {
  if (isRei) {
    // TODO translate: https://alltrails.atlassian.net/browse/GROW-18496
    return <UpsellFeatureList label="Everything you need to discover, plan, and navigate" rows={reiRows} />;
  }

  const rows = isInUs ? (memberDealsFirst ? usMemberDealsFirstRows : usDefaultRows) : nonUsRows;

  return <UpsellFeatureList label={<FormattedMessage defaultMessage="Plus membership includes" />} rows={rows} variant="compact" />;
}
